import { AddressForm } from 'components/addressForm/addressForm';

import template from './shippingAddressForm.html';

export const ShippingAddressForm = angular
    .module('checkout.components.shippingAddressForm', [
        AddressForm
    ]).component('shippingAddressForm', {
        template,
        bindings: {
            shippingAddressForm: '=formController',
            model: '=',
            hideShippingAsBilling: '<',
            useAddressVerification: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/shippingAddressForm/shippingAddressForm.js